import { Avatar, Box, Card, CardContent, CardMedia, Divider, Grid, List, ListItem, ListItemText, Paper, Typography } from "@mui/material";
import React, { memo, useCallback, useEffect, useState, useTransition } from "react";
import { formatDataCalendar, formatDataDay, formatDataTime, formatTime } from "../../services/utils";
import { brand, gray } from "../../mui/shared-theme/themePrimitives";
import { mapDispatchToPainelProps, mapStateToPainelProps, PainelViewProps } from "./painel.controller";
import { connect } from "react-redux";
import ShowDialog from "../../components/showDialog";
const logo = require('url:../../../assets/logo.png')
const medico = require('url:../../../assets/medico1.png')





var start = false
function PainelMain(props: PainelViewProps) {
    const [startPainel, setStartPainel] = useState(false)
    const { chamando_paciente, rows_call_done } = props.painelState
    const { readPacientesBySitChamouToday } = props.painelActions


    console.log("props em PainelMain", props)
    useEffect(() => {
        console.log("chamou useEffect em PainelMain")
        teste();
        if (start) {
            setTimeout(() => {
                readPacientesBySitChamouToday()
            }, 10000)
        }

    }, [startPainel])

    const teste = () => {
        let scriptElement = document.getElementById("function_speak_text");
        console.log("scriptElement", scriptElement)
        if (scriptElement) {

            console.log("chamou a funcao speakText da webview", scriptElement.textContent)
            
        }
    }

    const Multmidia = useCallback(() => {
        return (
            <iframe

                src="https://www.youtube.com/embed?listType=playlist&list=RDxzCFvfzWz2c&rel=0&controls=0&showinfo=0&modestbranding=0&autoplay=1&vq=720"
                title="Amora"
                allow="autoplay; accelerometer; encrypted-media; gyroscope"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
                style={{ border: 0, display: "flex", flex: 1 }}
                loading="lazy"

            ></iframe>
        )
    }, [])


    const DataHoraDisplay = useCallback(() => {
        const [data, setData] = useState(new Date())
        const [isPending, startTransition] = useTransition()
        useEffect(() => {
            // Set up an interval to update the time every 1000 milliseconds (1 second)
            const intervalId = setInterval(() => {
                startTransition(() => {
                    setData(new Date());
                })
            }, 1000);

            // Clean up the interval when the component unmounts to prevent memory leaks
            return () => clearInterval(intervalId);
        }, []); // The empty dependency array ensures the effect runs only once on mount

        return (
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <Typography variant="subtitle1" color={gray[300]}>{formatDataDay(data.toISOString())}</Typography>
                <Typography variant="h1" color={brand[500]}>{formatTime(data.toISOString())}</Typography>
            </Box>
        )
    }, [])


    return (
        <Box
            key={"main"}
            sx={{ display: "flex", flex: 1, flexDirection: "row", width: "100%", margin: 1 }}
        >
            <ShowDialog
                close={() => { setStartPainel(true); start = true }}
                msg="Confirmar inicio das chamadas"
                ok={() => { setStartPainel(true); start = true }}
                open={!startPainel}
                title="Start Chamadas"
            />
            <Grid container spacing={1} display={"flex"} flex={1}>
                <Grid size={{ lg: 3, md: 3 }} display={"flex"} flex={1}>
                    <Card
                        key={"card-side"}
                        sx={{ display: "flex", flex: 1, flexDirection: "column", borderColor: brand[500] }}

                    >
                        <Box sx={{ maxWidth: 350 }}>
                            <CardMedia
                                sx={{ objectFit: "cover" }}
                                image={logo}
                                title="logomarca"
                                component={"img"}
                            />
                        </Box>

                        <CardContent sx={{ display: "flex", flex: 1, flexDirection: "column" }}>
                            <Typography variant="subtitle1" textAlign={"center"} color={gray[300]}>Ultimas Chamadas</Typography>
                            <Divider sx={{ borderColor: brand[500] }} />
                            {/* loop inicio */}
                            {rows_call_done.map((value, idx) => (
                                <Box key={idx} sx={{ mt: 1 }}>
                                    <Typography variant="body1" fontSize={20} color={brand[500]}>{value.nome}</Typography>
                                    <Box sx={{ display: "flex", flex: 1, flexDirection: "row", justifyContent: "space-between" }}>
                                        <Typography variant="subtitle2" color="textSecondary">{value.atendimento.medico.nome}</Typography>
                                        <Typography variant="subtitle2" color="textSecondary">{value.atendimento.sala_desc}</Typography>
                                    </Box>
                                </Box>

                            ))}

                        </CardContent>
                        <DataHoraDisplay />
                    </Card>

                </Grid>
                <Grid size={{ lg: 9, md: 9 }} display={"flex"} flex={1}>
                    {/* visivel somente quando estiver chamando */}
                    {chamando_paciente.chamando && chamando_paciente.paciente._id && (
                        <Card
                            key={"card-chamada"}
                            sx={{ display: "flex", flex: 1, flexDirection: "column", borderColor: brand[500] }}
                        >
                            <Paper elevation={1} sx={{ display: "flex", justifyContent: "center" }} >
                                <Typography variant="button" fontSize={50} color={brand[500]}>Chamando Paciente</Typography>
                            </Paper>
                            <Box sx={{ display: "flex", flex: 1, flexDirection: "column", alignItems: "center", justifyContent: "space-evenly" }}>
                                <Typography sx={{}} variant="h1" fontSize={70}>{chamando_paciente.paciente.nome}</Typography>
                            </Box>
                            <Box sx={{ display: "flex", flexDirection: "row", p: 2, border: 1, borderColor: brand[500], borderRadius: 5 }}>
                                <Avatar
                                    alt={chamando_paciente.paciente.atendimento.medico.nome}
                                    src={medico}
                                    sx={{ width: 150, height: 150 }}
                                />

                                <Box sx={{ display: "flex", flex: 1, flexDirection: "column", pl: 3 }}>
                                    <Typography variant="h2" fontSize={55} color={brand[300]}>{chamando_paciente.paciente.atendimento.medico.nome}</Typography>
                                    <Typography variant="h5" fontSize={55} color="textSecondary">{chamando_paciente.paciente.atendimento.sala_desc}</Typography>
                                </Box>
                            </Box>

                        </Card>
                    )}
                    <Card
                        key={"card-multmidia"}
                        sx={{ display: chamando_paciente.chamando ? "none" : "flex", flex: 1, flexDirection: "column", borderColor: brand[500], }}

                    >
                        <Multmidia />
                    </Card>


                </Grid>


            </Grid>
        </Box>
    )
}

const PainelMainView = memo(PainelMain, (prev, next) => {
    return prev.painelState.chamando_paciente.chamando === next.painelState.chamando_paciente.chamando &&
        prev.painelState.changeList === next.painelState.changeList

})

export default connect(mapStateToPainelProps, mapDispatchToPainelProps)(PainelMain)